<template>
  <v-dialog
    v-model="dialog"
    width="unset"
    class="preview-modal">
    <v-carousel
      hide-delimiters
      height="80vh">
      <v-carousel-item
        v-for="(item,i) in items"
        :key="i">
        <img
          :src="$convertImgix(`${item}?w=1024`)"
          class="preview-image"
          alt="preview-image">
      </v-carousel-item>
    </v-carousel>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    dialog: {
      get () {
        return this.value
      },
      set (newVal) {
        this.$emit('input', newVal)
      }
    }
  },
  methods: {
    closeDialog () {
      this.dialog = false
    }
  }
}
</script>

<style scoped>
.preview-image {
  height: 80vh;
  width: auto;
  max-width: auto !important;
  object-fit: contain;
}

.preview-modal {
  z-index: 10000;
}
</style>
